import {StoreItemCategory} from '../../entity_datas/StoreEnums'
import {LobbyImage, StoreExpansionType} from '@colonist/types'
import {BaseStoreItem} from '../BaseStoreItem'
import {TranslationObject, TranslationArrayKeys} from '@colonist/i18n'

export class SIExpansionClassic56P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.Classic56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classic56P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.classic56P.description'
    price = 2800
    image = LobbyImage.StoreItemExpansionClassic56P
    activeInStore = true
}

export class SIExpansionClassic78P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.Classic78P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.classic78P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.classic78P.description'
    price = 2800
    image = LobbyImage.StoreItemExpansionClassic78P
    activeInStore = true
}

export class SIExpansionSeafarers4P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.Seafarers4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarers4P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.seafarers4P.description'
    price = 2800
    image = LobbyImage.StoreItemSeafarers4P
    activeInStore = true
}

export class SIExpansionSeafarers56P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.Seafarers56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarers56P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.seafarers56P.description'
    price = 2800
    image = LobbyImage.StoreItemSeafarers56P
    activeInStore = true
}

export class SIExpansionCitiesAndKnights4P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.CitiesAndKnights4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.citiesAndKnights4P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.citiesAndKnights4P.description'
    price = 2800
    image = LobbyImage.StoreItemCitiesAndKnights4P
    activeInStore = true
}

export class SIExpansionCitiesAndKnights56P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.CitiesAndKnights56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.citiesAndKnights56P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.citiesAndKnights56P.description'
    price = 2800
    image = LobbyImage.StoreItemCitiesAndKnights56P
    activeInStore = true
}

export class SIExpansionCitiesAndKnightsSeafarers4P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.CitiesAndKnightsSeafarers4P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.description'
    price = 2800
    image = LobbyImage.StoreItemCitiesAndKnightsSeafarers4P
    activeInStore = true
}

export class SIExpansionCitiesAndKnightsSeafarers56P extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.CitiesAndKnightsSeafarers56P
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.description'
    price = 2800
    image = LobbyImage.StoreItemCitiesAndKnightsSeafarers56P
    activeInStore = true
}

export class SIExpansionTradersAndBarbarians extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.TradersAndBarbarians
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.tradersAndBarbarians.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.tradersAndBarbarians.description'
    price = 2800
    image = LobbyImage.XMark
}

export class SIExpansionExplorersAndPirates extends BaseStoreItem {
    category = StoreItemCategory.Expansion
    type = StoreExpansionType.ExplorersAndPirates
    name: TranslationObject = {key: 'strings:colonistCommon.gameModes.explorersAndPirates.title'}
    description: TranslationArrayKeys = 'strings:colonistCommon.gameModes.explorersAndPirates.description'
    price = 2800
    image = LobbyImage.XMark
}
